
// this file is automatically generated by git.version.ts script
export const versions = {
  version: '0.13.5',
  revision: '865c9fb2',
  branch: 'release/0.13.5'
};